import { render } from "./TitleH1.vue?vue&type=template&id=13a0d424&scoped=true"
import script from "./TitleH1.vue?vue&type=script&lang=js"
export * from "./TitleH1.vue?vue&type=script&lang=js"

import "./TitleH1.vue?vue&type=style&index=0&id=13a0d424&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a0d424"]])

export default __exports__